import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets () {
    return ['backdrop']
  }

  initialize () {
    this.open()
    this.backdropTarget.addEventListener('click', this.close)
  }

  open () {
    document.body.classList.add('is-fixed')
    this.element.classList.add('is-visible')
    this.element.removeAttribute('aria-hidden')
  }

  close () {
    document.body.classList.remove('is-fixed')
    this.element.classList.remove('is-visible')
    this.element.setAttribute('aria-hidden', true)
  }
}
